// Lib
import React from 'react';
import { isEmpty } from 'lodash/fp';

// Selectors
import { useFilteredChildIds } from '../useFilteredChildIds';

// Components
import CommentAttached from './CommentAttached';

// Types
import { ImMNElement } from '../../../common/elements/elementModelTypes';

// Styles
import './AttachedCommentsContainer.scss';

type AttachedCommentsContainerProps = {
    elementId: string;
    element: ImMNElement;
    currentBoardId: string;
    permissions: number;
    gridSize: number;
    isPresentational: boolean;
    popupCssSelectorPrefix?: string;
    // Allows the consumer to filter which child elements are rendered
    // E.g. Document Modals only want to render the inline attached comments
    elementFilterFunction?: (element: ImMNElement) => boolean;
};

const AttachedCommentsContainer: React.FC<AttachedCommentsContainerProps> = (props) => {
    const {
        elementId,
        currentBoardId,
        gridSize,
        isPresentational,
        permissions,
        elementFilterFunction,
        popupCssSelectorPrefix,
    } = props;

    const childIds = useFilteredChildIds(elementId, elementFilterFunction);

    if (!childIds || isEmpty(childIds)) return null;

    return (
        <div className="AttachedCommentsContainer">
            {childIds.map((childId) => (
                <CommentAttached
                    key={childId}
                    elementId={childId}
                    currentBoardId={currentBoardId}
                    gridSize={gridSize}
                    permissions={permissions}
                    isPresentational={isPresentational}
                    popupCssSelectorPrefix={popupCssSelectorPrefix}
                />
            ))}
        </div>
    );
};

export default AttachedCommentsContainer;
